import request from '..'
import { useAuthStore } from './auth.store'
import {
  ForgotPasswordResponse,
  ResetPasswordPayload,
  ResetPasswordResponse,
  SelectTenantPayload,
  SelectTenantResponse,
  SignInPayload,
  SignInResponse,
  SignUpPayload,
  SignUpResponse,
} from './auth.type'

const signIn = async (data: SignInPayload): Promise<SignInResponse> => {
  const res = await request.post<DetailResponse<SignInResponse>>('/v1/auth/sign-in', data)

  return res.data.data
}

const selectTenant = async (data: SelectTenantPayload): Promise<SelectTenantResponse> => {
  const res = await request.post<DetailResponse<SelectTenantResponse>>(
    '/v1/auth/select-tenant',
    { tenant_id: data.tenant_id },
    {
      headers: {
        Authorization: `Bearer ${data.temp_token}`,
        'Skip-Auth': true,
      },
    }
  )

  return res.data.data
}

const signUp = async (data: SignUpPayload) => {
  const res = await request.post<DetailResponse<SignUpResponse>>('/v1/auth/sign-up', data)

  return res.data.data
}

const resetPassword = async (data: ResetPasswordPayload) => {
  const { new_password, token } = data
  const res = await request.post<DetailResponse<ResetPasswordResponse>>(
    '/v1/auth/reset-password',
    { new_password },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Skip-Auth': true,
      },
    }
  )
  return res.data
}

const forgotPassword = async (email: string) => {
  const res = await request.post<DetailResponse<ForgotPasswordResponse>>(
    '/v1/auth/forgot-password',
    { email }
  )
  return res.data
}

const refreshToken = async () => {
  const token = useAuthStore.getState().refreshToken

  const res = await request.post<{
    data: { token: string; refresh_token: string; tenants?: any[]; temp_token?: string }
  }>(
    '/v1/auth/refresh-token',
    {
      refresh_token: token,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Skip-Auth': true,
      },
    }
  )

  return res.data?.data
}

export const AuthApi = {
  signIn,
  selectTenant,
  signUp,
  resetPassword,
  forgotPassword,
  refreshToken,
}
